import {MAPPA} from './MappaTypes'

export const changeMappa = mappa => {
    return {
        type:MAPPA,
        load: mappa
    }
}
export const selectNewMappa = (mappa) => {

    return (dispatch) => {
        dispatch(changeMappa(mappa))
    }

}